export default __webpack_public_path__ + "static/media/addButtonPrimary.b89388e9.svg";